const TableHeader = ({ columns }) => (
  <thead className="sticky top-0 z-20 bg-btn-secondary shadow-sm">
    <tr>
      {columns.map(col => (
        <th key={col} className="px-3 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-b border-gray-200">
          {col}
        </th>
      ))}
    </tr>
  </thead>
);

export default TableHeader;